export var entityKeys = {
  goal: 'goal'
};
export var testIds = {
  form: 'link-create-goal-form',
  name: 'link-create-goal-name',
  site: 'link-create-goal-site-picker',
  error: 'link-create-goal-form-error'
};
export var Fields = /*#__PURE__*/function (Fields) {
  Fields["Name"] = "name";
  return Fields;
}({});